import React, { useState } from "react";
import "./App.css";

function App() {
  const [user, setUser] = useState("");
  const [pass, setPass] = useState("");
  const [loggedIn, setLoggedIn] = useState(false);

  const handleLogin = () => {
    if (user === "admin" && pass === "1234") {
      setLoggedIn(true);
    } else {
      alert("Invalid credentials");
    }
  };

  const handleLogout = () => {
    setUser("");
    setPass("");
    setLoggedIn(false);
  };

  return (
    <div className="main">
      <div className="card">
        <h1 className="title">EXP 9 - Docker React App</h1>

        {!loggedIn ? (
          <>
            <p className="subtitle">Login to continue</p>

            <input
              className="input"
              placeholder="Username"
              value={user}
              onChange={(e) => setUser(e.target.value)}
            />

            <input
              className="input"
              type="password"
              placeholder="Password"
              value={pass}
              onChange={(e) => setPass(e.target.value)}
            />

            <button className="btn" onClick={handleLogin}>
              Login
            </button>
          </>
        ) : (
          <>
            <h2 className="welcome">Welcome, {user} 👋</h2>
            <p className="subtitle">You are successfully logged in</p>

            <button className="btn logout" onClick={handleLogout}>
              Logout
            </button>
          </>
        )}
      </div>
    </div>
  );
}

export default App;